import * as React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { updateSearch } from 'bernie-core';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { UitkLayoutPosition } from 'uitk-react-layout-position';
import { UitkPriceLockup, UitkPriceLockupAlign } from 'uitk-react-price-lockup';
import { UitkText } from 'uitk-react-text';
import { UitkSpacing } from 'uitk-react-spacing';
import { TextTheme } from '../../../../../../constants';
import { ButtonTracked } from '../../../../../../utils/click-trackers';
import { mapDisclaimerToMessageContent } from '../../../../../../utils/disclaimer';
import { useStores } from '../../../../../../utils/hooks';
import { objectArrayToArrayConversion } from '../../../../../../helpers/popup-message-array-helper';
import { getPriceDetails } from '../../../../../../business';
import { PopupMessage } from '../../../../../common/popup-message';
import { ActivityFeature } from '../components/activity-feature';
export var ActivityCardContentBottom = function (_a) {
  var _b, _c;
  var activity = _a.activity,
    activityGroup = _a.activityGroup;
  var _d = getPriceDetails(activity),
    strikeThroughPrice = _d.strikeThroughPrice,
    lockupPrice = _d.lockupPrice,
    lockupFormattedPoints = _d.lockupFormattedPoints,
    priceSubtextFirst = _d.priceSubtextFirst,
    accessibilityPrice = _d.accessibilityPrice,
    priceDisclaimer = _d.priceDisclaimer,
    leadingCaption = _d.leadingCaption,
    isPointsFirstDisplay = _d.isPointsFirstDisplay,
    isStrikeThroughFirstDisplay = _d.isStrikeThroughFirstDisplay;
  var _e = mapDisclaimerToMessageContent(priceDisclaimer),
    disclaimerDialog = _e.disclaimerDialog,
    content = _e.content,
    triggerAnalytics = _e.triggerAnalytics,
    accessibility = _e.accessibility;
  var analytics = useStores().analytics;
  var location = useLocation();
  var history = useHistory();
  var linkRef = React.useRef(null);
  var priceDisclaimerId = activityGroup ? "legal-price-disclaimer-".concat(activity.id, "-").concat(activityGroup) : "legal-price-disclaimer-".concat(activity.id);
  var activityForDestinationSearch = activity;
  var freeCancellationFeatureForDestinationSearch = activityForDestinationSearch.features.freeCancellationFeature;
  var handleClick = function () {
    linkRef.current = document.activeElement;
    updateSearch({
      location: location,
      history: history,
      newParams: {
        pwaDialogNested: priceDisclaimerId
      }
    });
  };
  return React.createElement(React.Fragment, null, React.createElement(UitkLayoutFlex, {
    tag: "section",
    direction: "column",
    "data-testid": "activity-tile-card-content-bottom"
  }, activity.features.loyaltyEarnAwards && React.createElement(UitkLayoutFlexItem, {
    className: "uitk-type-300 color-accent-3"
  }, React.createElement(UitkSpacing, {
    margin: {
      blockend: 'one'
    }
  }, React.createElement(ActivityFeature, {
    label: activity.features.loyaltyEarnAwards.label,
    mark: activity.features.loyaltyEarnAwards.mark,
    isLoyaltyEarnDisplay: true,
    "data-testid": "loyalty-earn-award--feature"
  }))), React.createElement(UitkSpacing, {
    margin: {
      blockend: 'one'
    }
  }, React.createElement(UitkLayoutFlexItem, null, React.createElement(UitkText, {
    size: 200,
    theme: (freeCancellationFeatureForDestinationSearch === null || freeCancellationFeatureForDestinationSearch === void 0 ? void 0 : freeCancellationFeatureForDestinationSearch.theme) ? TextTheme[freeCancellationFeatureForDestinationSearch.theme] : 'positive',
    "data-testid": "activity-free-cancellation"
  }, freeCancellationFeatureForDestinationSearch === null || freeCancellationFeatureForDestinationSearch === void 0 ? void 0 : freeCancellationFeatureForDestinationSearch.text))), React.createElement(UitkLayoutFlexItem, null, React.createElement(UitkLayoutPosition, {
    position: {
      zindex: 'layer2'
    }
  }, React.createElement(UitkPriceLockup, {
    align: UitkPriceLockupAlign.LEFT,
    a11yPrice: accessibilityPrice || '',
    lockupFormattedPoints: lockupFormattedPoints || undefined,
    lockupPrice: lockupPrice || undefined,
    priceSubtextFirst: priceSubtextFirst || undefined,
    strikeThroughPrice: strikeThroughPrice || undefined,
    a11yStrikeThroughDialogTrigger: priceDisclaimer ? accessibility : undefined,
    leadingCaption: leadingCaption || undefined,
    isPointsFirst: isPointsFirstDisplay,
    isStrikeThroughFirst: isStrikeThroughFirstDisplay,
    strikeThroughTrigger: React.createElement(ButtonTracked, {
      onClick: handleClick,
      innerRef: linkRef,
      linkName: (triggerAnalytics === null || triggerAnalytics === void 0 ? void 0 : triggerAnalytics.linkName) || '',
      rfrr: (triggerAnalytics === null || triggerAnalytics === void 0 ? void 0 : triggerAnalytics.referrerId) || '',
      className: "no-background"
    })
  }), priceDisclaimer && React.createElement(PopupMessage, {
    dialogId: priceDisclaimerId,
    dismissAction: disclaimerDialog,
    disclaimer: priceDisclaimer,
    analytics: analytics,
    isNestedPopup: true,
    messages: objectArrayToArrayConversion(content),
    linkRef: linkRef
  }))), ((_b = activity.leadTicketPrice.priceLockup) === null || _b === void 0 ? void 0 : _b.priceSubtextStandard) && React.createElement(UitkSpacing, {
    margin: {
      blockstart: 'one'
    }
  }, React.createElement(UitkLayoutFlexItem, null, React.createElement(UitkText, {
    size: 200,
    "data-testid": "activity-taxes-and-fees-message"
  }, activity.leadTicketPrice.priceLockup.priceSubtextStandard.map(function (message, count) {
    return React.createElement(UitkText, {
      key: count
    }, message);
  })))), ((_c = activity.features.volumePricing) === null || _c === void 0 ? void 0 : _c.description) && React.createElement(UitkSpacing, {
    margin: {
      blockstart: 'one'
    }
  }, React.createElement(UitkLayoutFlexItem, null, React.createElement(UitkText, {
    size: 100,
    "data-testid": "activity-volume-based-pricing"
  }, activity.features.volumePricing.description)))));
};